<template>
  <v-card>
    <v-card-title primary-title style="padding-left: 8px; padding-bottom: 8px">
      <span class="headline mb-0">{{ $t('B0300.titles[2]') }}</span>
    </v-card-title>
    <v-card-actions>
      <v-btn @click="addPoItems" small v-if="editable && isPaid">{{
        $t('app.buttons.poDetect')
      }}</v-btn>
      <table-upload
        :title="$t('app.buttons.ivUpload')"
        @input="ivUpload"
        v-if="editable && isPaid"
      />
      <v-btn @click="addFreeItems" small v-if="editable && isUnPaid">{{
        $t('app.buttons.addFreeItems')
      }}</v-btn>
      <v-btn @click="addPackages" small v-if="editable">{{
        $t('app.buttons.addPackages')
      }}</v-btn>
      <v-btn
        :disabled="selected.length === 0"
        @click="removeItems"
        small
        v-if="editable"
        >{{ $t('app.buttons.remove') }}</v-btn
      >
      <table-upload
        :title="$t('app.buttons.sytcIvCsvUpload')"
        @input="invoiceUpload"
        v-if="editable && isPaid"
      />
      <table-upload
        :title="$t('app.buttons.skuUpload')"
        @input="skuUpload"
        v-if="editable && isUnPaid"
      />
      <v-spacer></v-spacer>
      <div style="display: flex">
        <div>
          <div class="statistic">
            <div class="label">{{ $t('app.labels.totalAmount') }}:</div>
            <div class="value">
              {{ total | currency({ symbol: '', fractionCount: 2 }) }}
            </div>
          </div>
          <div class="statistic">
            <div class="label">合計数量:</div>
            <div class="value">
              {{ totalQty | currency({ symbol: '', fractionCount: 0 }) }}
            </div>
          </div>
        </div>
        <div style="margin-left: 15px">
          <div class="statistic">
            <div class="label">合計N/W:</div>
            <div class="value">
              {{ totalNetWeight | currency({ symbol: '', fractionCount: 2 }) }}
            </div>
          </div>
          <div class="statistic">
            <div class="label">合計G/W:</div>
            <div class="value">
              {{
                totalGrossWeight | currency({ symbol: '', fractionCount: 2 })
              }}
            </div>
          </div>
          <div class="statistic">
            <div class="label">合計M3:</div>
            <div class="value">
              {{ totalM3 | currency({ symbol: '', fractionCount: 3 }) }}
            </div>
          </div>
        </div>
      </div>
    </v-card-actions>
    <v-data-table
      :headers="headers"
      :items="invoice.items"
      :rows-per-page-items="[10]"
      class="elevation-1 mt-2 mb-2 inline-edit"
      item-key="seq"
      select-all
      v-model="selected"
    >
      <template slot="items" slot-scope="props">
        <td class="td-cb">
          <v-checkbox
            :disabled="invoice.isUsed == true"
            hide-details
            primary
            v-model="props.selected"
          ></v-checkbox>
        </td>
        <td>{{ props.item.poNo }}</td>
        <td>{{ props.item.lotNo }}</td>
        <td>{{ props.item.skuCode }}</td>
        <td>{{ props.item.productCode }}</td>
        <td>{{ props.item.unit }}</td>
        <td v-if="isUnPaid">
          <v-text-field
            :disabled="!editable"
            :placeholder="$t('app.labels.invoice.item.unitPrice')"
            :rules="[
              (v) => !!v || 'unitPrice is required.',
              (v) => v >= 0.01 || 'unitPrice must bigger than equal 0.01',
            ]"
            clearable
            v-model.number="props.item.unitPrice"
          />
        </td>
        <td v-if="isPaid">{{ props.item.unitPrice }}</td>
        <td>{{ props.item.currencyCode }}</td>
        <td>
          <v-text-field
            :disabled="!editable"
            :placeholder="$t('B0300.labels.qty')"
            :rules="[
              (v) => !!v || 'qty is required.',
              (v) => v > 0 || 'qty must bigger than 0',
            ]"
            @change="changeQty(props.item)"
            clearable
            v-model.number="props.item.qty"
          />
        </td>
        <td>
          {{
            subTotal(props.item) | currency({ symbol: '', fractionCount: 2 })
          }}
        </td>
        <td>
          <remote-autocomplete
            :placeholder="$t('app.labels.invoice.item.origin')"
            :value="props.item.originCountryCode"
            @input="(v) => changeOriginCountry(props.item, v)"
            returnObject
            style="width: 200px"
            url="countries/kv"
          ></remote-autocomplete>
        </td>
        <td>
          <span>{{ isPaid ? '有償' : '無償' }}</span>
        </td>
        <td v-if="isUnPaid">
          <v-text-field
            :placeholder="$t('B0300.labels.incoterm')"
            clearable
            disabled
            v-if="isUnPaid"
            v-model="props.item.incotermCode"
          />
        </td>
        <td v-if="isPaid">{{ props.item.incotermCode }}</td>
        <td>
          <!-- <remote-autocomplete
            :disabled="!editable"
            :placeholder="$t('app.labels.warehouse')"
            :value="props.item.scWarehouseId"
            @input="(v)=>changeScWarehouse(props.item,v)"
            returnObject
            url="warehouses/sjl-kv"
          />-->
          {{ props.item.scWarehouseName }}
        </td>
        <td>{{ props.item.payment }}</td>
      </template>
    </v-data-table>
    <search-order-dialog :invoice="invoice" ref="searchOrderDialog" />
    <search-product-dialog ref="searchProductDialog" />
    <invoice-dialog ref="invoiceDialog" />
  </v-card>
</template>
<script>
import SearchOrderDialog from './SearchOrderDialog'
import SearchProductDialog from './SearchProductDialog'
import InvoiceDialog from './InvoiceDialog'
export default {
  components: { SearchOrderDialog, InvoiceDialog, SearchProductDialog },
  props: ['invoice', 'purchaseOrder', 'type'],
  data() {
    return {
      max: '',
      uploadData: [],
      packageData: [],
      itemData: [],
      invType: '',
      show: false,
      selected: [],
      headers: [
        { text: this.$t('app.labels.poNo'), value: 'poNo', sortable: false },
        { text: this.$t('app.labels.lotNo'), value: 'lotNo', sortable: false },
        {
          text: this.$t('app.labels.skuCode'),
          value: 'skuCode',
          sortable: false,
        },
        {
          text: this.$t('app.labels.productCode'),
          value: 'productCode',
          sortable: false,
        },
        { text: this.$t('app.labels.unit'), value: 'unit', sortable: false },
        {
          text: this.$t('app.labels.invoice.item.unitPrice'),
          value: 'unitPrice',
          width: '150px',
          sortable: false,
        },
        {
          text: this.$t('app.labels.currency'),
          value: 'currency',
          width: '150px',
          sortable: false,
        },
        {
          text: this.$t('app.labels.qty'),
          value: 'qty',
          width: '100px',
          sortable: false,
        },
        {
          text: this.$t('app.labels.price'),
          value: 'subTotal',
          width: '100px',
          sortable: false,
        },
        {
          text: this.$t('app.labels.invoice.item.origin'),
          value: 'countryName',
          width: '200px',
          sortable: false,
        },
        {
          text: this.$t('app.labels.division'),
          value: 'paid',
          editable: false,
          sortable: false,
        },
        {
          text: this.$t('B0300.labels.incoterm'),
          value: 'incotermCode',
          sortable: false,
        },
        {
          text: this.$t('app.labels.warehouse'),
          value: 'warehouseName',
          width: '300px',
          sortable: false,
        },
        {
          text: 'payment',
          value: 'payment',
          sortable: false,
        },
      ],
    }
  },
  watch: {},
  computed: {
    isPaid() {
      return (
        this.invoice.isPaid == true || 
        this.type === 'paid' ||
        (this.invoice.items.length > 0 &&
          this.invoice.items.filter((i) => this.isExist(i.poId)).length > 0)
      )
    },
    isUnPaid() {
      return (
        this.invoice.isPaid == false || 
        this.type === 'unpaid' ||
        (this.invoice.items.length > 0 &&
          this.invoice.items.filter((i) => this.isExist(i.poId)).length == 0)
      )
    },
    total() {
      return this.invoice.items
        .filter((i) => i.qty != null && i.unitPrice != null)
        .reduce((t, i) => t + this.subTotal(i), 0)
    },
    totalQty() {
      return this.invoice.items
        .filter((i) => i.qty != null)
        .reduce((t, i) => t + i.qty, 0)
    },

    totalNetWeight() {
      return this.invoice.packages
        .filter((i) => i.totalNetWeight != null)
        .reduce((t, i) => t + Number(i.totalNetWeight), 0)
    },
    totalGrossWeight() {
      return this.invoice.packages
        .filter((i) => i.totalGrossWeight != null)
        .reduce((t, i) => t + Number(i.totalGrossWeight), 0)
    },
    totalM3() {
      return this.invoice.packages
        .filter((i) => i.totalVolume != null)
        .reduce((t, i) => t + Number(i.totalVolume), 0)
    },
    editable() {
      return (
        this.invoice &&
        (this.invoice.isUsed == null || this.invoice.isUsed == false)
      )
    },
  },

  methods: {
    isExist(value) {
      return value != undefined && value != null && value != ''
    },
    cartonQty(pkg) {
      return pkg.cartonEndNo - pkg.cartonStartNo + 1
    },
    changeQty(item) {
      console.log(item)
      if (item.poNo != null && item.poNo != '') {
        this.invoice.packages
          .filter((p) => p.poNo === item.poNo)
          .forEach((p) => (p.totalQty = item.qty))
      } else {
        this.invoice.packages
          .filter((p) => p.skuCode === item.skuCode)
          .forEach((p) => (p.totalQty = item.qty))
      }
    },
    changeOriginCountry(item, val) {
      item.originCountryCode = val.value
      item.originCountryName = val.text
    },
    changeScWarehouse(item, val) {
      item.scWarehouseName = val.text.substring(val.text.indexOf(':') + 1)
      item.scWarehouseId = val.value
      item.scWarehouseCode = val.code
    },
    subTotal(item) {
      return Math.round(item.unitPrice * item.qty * 100) / 100
    },
    hasSamePo(selected) {
      for (var i = 0; i < this.invoice.items.length; i++) {
        for (var j = 0; j < selected.length; j++) {
          if (this.invoice.items[i].poNo == selected[j].poNo) {
            return true
          }
        }
      }
    },
    hasSameFree(selected) {
      for (var i = 0; i < selected.length; i++) {
        if (
          this.invoice.items.filter(
            (item) => item.skuCode === selected[i].code && item.paid === 0
          ).length > 0
        ) {
          return true
        }
      }
    },
    hasDifPartner(selected) {
      var temp = []
      temp = [...selected, ...this.invoice.items]
      var partner = temp
        .filter((i) => !!i.partnerId)
        .map((i) => i.partnerId)
        .reduce((t, i) => {
          if (t.indexOf(i) == -1) {
            t.push(i)
          }
          return t
        }, [])
      if (partner.length > 1) {
        return true
      } else {
        return false
      }
    },
    hasDifCompany(selected) {
      var temp = []
      temp = [...selected, ...this.invoice.items]
      var company = temp
        .filter((i) => !!i.companyId)
        .map((i) => i.companyId)
        .reduce((t, i) => {
          if (t.indexOf(i) == -1) {
            t.push(i)
          }
          return t
        }, [])
      if (company.length > 1) {
        return true
      } else {
        return false
      }
    },
    hasSameItem() {
      for (var i = 0; i < this.invoice.packages.length; i++) {
        for (var j = 0; j < this.selected.length; j++) {
          if (
            this.invoice.packages[i].poNo === this.selected[j].poNo &&
            this.invoice.packages[i].skuCode === this.selected[j].skuCode
          ) {
            return true
          }
        }
      }
    },
    sameLoadingPort(item) {
      var a = item
        .filter((p) => p.loadingPortCode != null)
        .map((p) => p.loadingPortCode)
        .reduce((total, code) => {
          if (total.indexOf(code) == -1) {
            total.push(code)
          }
          return total
        }, [])
      console.log(a)
      if (a.length > 1) {
        return false
      } else if (
        this.invoice.items &&
        this.invoice.items.length > 0 &&
        this.invoice.items[0].loadingPortCode != a[0]
      ) {
        return false
      } else {
        return true
      }
    },
    sameDischargePort(item) {
      var a = item
        .filter((p) => p.dischargePortCode != null)
        .map((p) => p.dischargePortCode)
        .reduce((total, code) => {
          if (total.indexOf(code) == -1) {
            total.push(code)
          }
          return total
        }, [])
      if (a.length > 1) {
        return false
      } else if (
        this.invoice.items &&
        this.invoice.items.length > 0 &&
        this.invoice.items[0].dischargePortCode != a[0]
      ) {
        return false
      } else {
        return true
      }
    },
    addPoItems() {
      this.$refs.searchOrderDialog.popup().then((selected) => {
        if (this.hasSamePo(selected)) {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('B0300.messages.errors.duplicatePO')
          )
        } else if (this.hasDifCompany(selected)) {
          this.$message('', '事業本部CDが異なっているため、追加できません。') //'different companies'
        } else if (this.hasDifPartner(selected)) {
          this.$message('', this.$t('B0300.messages.errors.partner_unique')) //'different partners'
        } else {
          this.invoice.items = [
            ...this.invoice.items,
            ...selected.map((s, index) => ({
              ...s,
              poItemId: s.id,
              id: null,
              seq: new Date().getTime() + index,
              qty: s.leftInvoice,
              max: s.leftInvoice,
            })),
          ]
          this.$emit('initData', selected)
        }
      })
    },
    addFreeItems() {
      this.$refs.searchProductDialog.popup().then((selected) => {
        if (this.hasSameFree(selected)) {
          this.$message(
            this.$t('app.messages.errors.title'),
            '該当無償商品が存在しているので、追加できません。'
          )
        }
        // else if (
        //   //items里面已经有諸掛 和 同时添加諸掛和其他无偿
        //   this.invoice.items.filter((item) => item.skuCode === '諸掛').length >
        //     0 ||
        //   (selected.length > 1 &&
        //     selected.filter((s) => s.skuCode === '諸掛').length > 0)
        // ) {
        //   this.$message(
        //     this.$t('app.messages.errors.title'),
        //     '１件のINVに諸掛と品番が同時に存在できません。'
        //   )
        //   return
        // }
        else {
          this.invoice.items = [
            ...this.invoice.items,
            ...selected.map((s, index) => ({
              skuCode: s.code,
              productCode: s.productCode,
              seq: new Date().getTime() + index,
              paid: 0,
              incotermCode: 'No　Commercial Value',
              currencyCode: 'USD',
            })),
          ]
        }
      })
    },
    removeItems() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          this.invoice.packages = this.invoice.packages.filter(
            (p) => this.selected.indexOf(p.item) === -1
          )
          this.invoice.items = this.invoice.items.filter(
            (i) => this.selected.indexOf(i) === -1
          )
          if (this.invoice.items.length === 0) {
            this.invoice.loadingPortCode = null
            this.invoice.dischargePortCode = null
            this.invoice.buId = null
            this.invoice.partnerId = null
          }
          this.selected = []
          this.$message('', this.$t('app.messages.removeSuccess'))
        }
      )
    },
    addPackages() {
      if (this.hasSameItem()) {
        this.$message(
          this.$t('app.messages.warning.title'),
          this.$t('B0300.messages.warning.existPackagedPO')
        )
        return
      }
      this.invoice.packages = [
        ...this.invoice.packages,
        ...this.selected.map((s, index) => ({
          item: s,
          ...s,
          itemSeq: s.seq,
          seq: new Date().getTime() + index * 1000,
          totalQty: s.qty,
          totalNetWeight: 0,
          totalGrossWeight: 0,
          totalVolume: 0,
        })),
      ]
      this.selected = []
    },
    ivUpload(data) {
      this.initDataByUpload(data)
    },
    initDataByUpload(data) {
      console.log(data)
      console.log(data.filter((d) => d.length > 0))

      data = data.filter((d) => d.length > 0)

      var poNos = []
      for (var i = 1; i < data.length; i++) {
        if (poNos.indexOf(data[i][0]) == -1) {
          poNos.push(String(data[i][0]))
        }
      }
      poNos = poNos.filter((po) => po && po != '')
      let po = poNos.join(',')
      var finalData = []
      this.$http.get(`/purchase-orders/get-po/${po}`).then((res) => {
        this.uploadData = res.data
        data.forEach((d, index) => {
          var po = this.uploadData.find((u) => u.poNo === String(d[0]))
          var item = { ...po, seq: new Date() + index * 1000 }
          if (po) {
            this.$set(item, 'totalNetWeight', d[9])
            this.$set(item, 'totalGrossWeight', d[10])
            this.$set(item, 'totalVolume', d[11])
            this.$set(item, 'cartonStartNo', d[7])
            this.$set(item, 'cartonEndNo', d[8])
            this.$set(item, 'flag', d[6])
            this.$set(item, 'qty', d[5])
            this.$set(item, 'totalQty', d[5])
            if (item.totalQty && item.cartonEndNo && item.cartonEndNo) {
              this.$set(
                item,
                'perCartonQty',
                item.totalQty / (item.cartonEndNo - item.cartonStartNo + 1)
              )
            }
            this.$set(item, 'invoiceNo', d[1])
            finalData.push(item)
          }
        })
        console.log(this.uploadData)
        console.log(poNos)
        if (poNos.length > this.uploadData.length) {
          this.$message(
            '',
            this.$t('B0300.messages.errors.po_not_found_upload')
          ) //'あるPOデータは存在しません。'
        } else {
          this.$emit('initUploadData', finalData)
        }
      })
    },
    invoiceUpload(data) {
      console.log(data)
      this.initInvoiceByUpload(data)
    },
    initInvoiceByUpload(data) {
      var poNos = []
      console.log(data)
      data = data.filter((d) => d.length > 0)
      console.log(data)

      for (var i = 1; i < data.length; i++) {
        if (
          data[i][1] &&
          data[i][2] &&
          Number(data[i][1]) > Number(data[i][2])
        ) {
          this.$message(
            '',
            'CartonNo Startの数値はCartonNo Endより大きく設定されません。CartonNo End must bigger than CartonNo Start.'
          )
          return
        }
        if (poNos.indexOf(String(data[i][0])) == -1) {
          poNos.push(String(data[i][0]))
        }
      }

      poNos = poNos.filter((po) => po && po != '')
      let po = poNos.join(',')

      var finalData = []
      this.$http.get(`/purchase-orders/get-po/${po}`).then((res) => {
        this.uploadData = res.data
        data.forEach((d, index) => {
          var po = this.uploadData.find((u) => u.poNo === String(d[0]))
          var item = { ...po, seq: new Date() + index * 1000 }
          if (po) {
            this.$set(item, 'cartonStartNo', d[1])
            this.$set(item, 'cartonEndNo', d[2])
            this.$set(item, 'perCartonQty', d[3])
            this.$set(item, 'totalNetWeight', d[4])
            this.$set(item, 'totalGrossWeight', d[5])
            this.$set(item, 'totalVolume', d[6])
            this.$set(item, 'totalQty', (d[2] - d[1] + 1) * d[3])

            finalData.push(item)
          }
        })
        if (poNos.length > this.uploadData.length) {
          this.$message('', 'あるPOデータは存在しません。')
        } else {
          this.$emit('initUploadData', finalData)
        }
      })
    },
    skuUpload(data) {
      console.log('skuload', data)
      // if (this.invoice.items.find((i) => i.skuCode === '諸掛')) {
      //   this.$message('', '１件のINVに諸掛と品番が同時に存在できません。')
      //   return
      // }
      data = data
        .filter((d) => d.length > 0)
        .filter((d) => d != null && d[0] != null && d[0] != '')
      var items = []
      var domestic = data.filter((d) => '諸掛' === d[0] || '諸掛' === d[1])
      for (var i = 1; i < data.length; i++) {
        if (domestic.length > 0) {
          data = domestic
          i = 0
        }
        var item = {
          seq: Date() + i * 1000,
          skuCode: String(data[i][0]),
          productCode: String(data[i][1]),
          unitPrice: Number(data[i][2]),
          qty: Number(data[i][3]),
          totalQty: Number(data[i][3]),
          originCountryCode: (data[i][4] && String(data[i][4])) || null,
          originCountryName: data[i][5] || null,
          incotermCode: 'No　Commercial Value',
          currencyCode: 'USD',
        }
        items.push(item)
        if (domestic.length > 0) {
          this.$emit('uploadUnpaidData', items)
          return
        }
      }
      this.$emit('uploadUnpaidData', items)
    },
  },
}
</script>

<style scoped>
.statistic {
  display: flex;
  flex-direction: row;
  font-size: 12px;
}
.statistic .label {
  width: 60px;
  text-align: right;
  color: gray;
}
.statistic .value {
  width: 80px;
  text-align: right;
}
</style>
